import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { PressReleaseService } from '../services/press-release.service';
import { createPressReleaseSlug, PressRelease } from '../models/press-release';

@Component({
  selector: 'app-press-release-list',
  standalone: true,
  imports: [
    CommonModule,  // *ngIf, *ngFor
    RouterModule,  // routerLink
    DatePipe       // | date
  ],
  templateUrl: './press-release-list.component.html',
  styleUrls: ['./press-release-list.component.css']
})
export class PressReleaseListComponent implements OnInit {
  pressReleases: PressRelease[] = [];

  constructor(
    private pressReleaseService: PressReleaseService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.pressReleaseService.getPressReleases().subscribe(releases => {
      console.log('Press Releases:', releases);
      this.pressReleases = releases;
    });
  }

  getReleaseSlug(release: PressRelease): string {
    return createPressReleaseSlug(release);
  }

  navigateToRelease(release: PressRelease) {
    if (release.id) {
      this.router.navigate(['/newsroom', this.getReleaseSlug(release)]);
    }
  }
}
